import { BaseQueryFn, createApi, defaultSerializeQueryArgs } from "@reduxjs/toolkit/query/react";
import { axiosBaseQueryApiSlice } from "services/src/etl-client/axios/axios-base-query";
import { inMemoryBaseQuery } from "services/src/etl-client/in-memory/in-memory-base-query";
import { EtlDataTagsEnum, getEtlDataEndpoints } from "../slices/etlData/etlData.endpoints";
import { TriggerFiltersTagsEnum, getTriggerFiltersEndpoints } from "../slices/formStep/triggerFilters.endpoints";

const setupApiSlice = (apiBaseQuery: BaseQueryFn) => createApi({
	baseQuery: apiBaseQuery,
	reducerPath: "etlApi",
	tagTypes: [
		...Object.values(TriggerFiltersTagsEnum),
		...Object.values(EtlDataTagsEnum),
	],
	serializeQueryArgs: (args) => defaultSerializeQueryArgs(args),
	endpoints: (builder) => ({
		...getTriggerFiltersEndpoints(builder),
		...getEtlDataEndpoints(builder),
	}),
});

export const apiSlice = setupApiSlice(
	import.meta.env.MODE === "test" || import.meta.env.STORYBOOK === "true"
		? inMemoryBaseQuery()
		: axiosBaseQueryApiSlice()
);

export type UseGetSelectedEtlImportQuery = ReturnType<typeof apiSlice.useGetSelectedEtlImportQuery>;
